import React, { useState, useEffect } from 'react';
import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { Skeleton } from '@mui/material';

const formatRevenue = (value) => {
  return value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};

const SalesChart = ({ data }) => {
  const [isChartReady, setIsChartReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsChartReady(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  if (!isChartReady) {
    return (
      <div style={{ width: '100%', height: 300 }}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={300}
          animation="wave"
          style={{
            borderRadius: 8,
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
          }}
        />
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <ComposedChart data={data} margin={{ top: 5, right: 50, bottom: 5, left: 0 }}>
        <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
        <XAxis dataKey="month" />
        <YAxis yAxisId="left" />
        <YAxis
          yAxisId="right"
          orientation="right"
          tickFormatter={formatRevenue}
          width={60}
        />
        <Tooltip
          formatter={(value, name) => {
            if (name === 'revenue') {
              return [
                `${value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`,
                'Revenue'
              ];
            }
            return [value, name.charAt(0).toUpperCase() + name.slice(1)];
          }}
        />
        <Legend />
        <Bar yAxisId="left" dataKey="sales" fill="#82ca9d" />
        <Line yAxisId="right" type="monotone" dataKey="revenue" stroke="#8884d8" />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default SalesChart;